const INITIAL_STATE = {
    list: [],
    areaInventoryList: [],
    inventoryList: [],
    confirmation: [],
    confirmationList: [],
    confirmationListDrone: [],
    confirmationPendingSentItens: [],
    confirmationListAll: [],
    rackList: [],
    pendingList: [],
    divergentList: [],
    inventoryConfig: {
        inventory: '',
        inventoryDescription: '',
        typeInventory: '',
        height: '',
        area: '',
        areaZone: '',
        areaCompanies: '',
        areaDescription: '',
        row: '',
        heightRequired: true,
        typeRequired: true,
        rowRequired: true,
        activeTab: 0
    }
};

export default function lineInventoryReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'LIST':
            return {
                ...state,
                list: action.listLine
            };
        case 'INVENTORY_LIST':
            return {
                ...state,
                inventoryList: action.listInventory,
            };
        case 'PENDING_LIST': {
            const dataGroupPending = action.listPending;
            return {
                ...state,
                pendingList: dataGroupPending
            };
        }
        case 'AREA_LIST': {
            return {
                ...state,
                areaInventoryList: action.listAreaInventory
            };
        }
        case 'SET_INVENTORY': {
            const configState = state.inventoryConfig;
            configState.inventory = action.inventory;
            const inventory = state.list.find((i) => { return i.id.toString() === action.inventory; });
            if (inventory !== undefined) {
                configState.inventoryDescription = inventory.fileName;
            }
            return {
                ...state,
                inventoryConfig: configState,
            };
        }
        case 'SET_INVENTORY_AREA': {
            const configState = state.inventoryConfig;
            configState.area = action.area;
            const area = state.areaInventoryList.find((i) => { return i.id === action.area; });

            if (area) {
                configState.areaZone = area.zonaPeca;
                configState.areaCompanies = area.company;
                configState.areaDescription = area.value;
            }
            return {
                ...state,
                inventoryConfig: configState,
            };
        }
        case 'SET_INVENTORY_ROW': {
            const configState = state.inventoryConfig;
            configState.row = action.row;
            return {
                ...state,
                inventoryConfig: configState,
            };
        }
        case 'SET_INVENTORY_HEIGHT': {
            const configState = state.inventoryConfig;
            configState.height = action.height;
            return {
                ...state,
                inventoryConfig: configState,
            };
        }
        case 'SET_INVENTORY_TYPE': {
            const configState = state.inventoryConfig;
            configState.typeInventory = action.typeInventory;
            return {
                ...state,
                inventoryConfig: configState,
            };
        }
        case 'SET_ACTIVE_TAB': {
            const configState = state.inventoryConfig;
            configState.activeTab = action.activeTab;
            return {
                ...state,
                inventoryConfig: configState,
            };
        }
        case 'RESET_RACK_LIST': {
            return {
                ...state,
                rackList: INITIAL_STATE.rackList,
            };
        }
        case 'SET_RACK_LIST': {
            return {
                ...state,
                rackList: action.rackList,
            };
        }
        case 'UPDATE_QUANTITY_ITEM_RACK': {
            const itemRack = state.rackList.find((i) => i.productId === action.productId);
            itemRack.qtStorage = action.quantity;

            return {
                ...state,
                rackList: state.rackList,
            };
        }
        case 'RESET_CONFIRMATION_INVENTORY':
            return {
                ...state,
                confirmation: INITIAL_STATE.confirmation,
                confirmationList: INITIAL_STATE.confirmationList,
                confirmationListAll: INITIAL_STATE.confirmationListAll,
                inventoryConfig: INITIAL_STATE.inventoryConfig,
                pendingList: INITIAL_STATE.pendingList,
                divergentList: []

            };
        case 'RESET_PENDING_SEND_ITENS':
            return {
                ...state,
                confirmationPendingSentItens: INITIAL_STATE.confirmationPendingSentItens,
            };
        case 'CREATE_CONFIRMATION_INVENTORY':
            return {
                ...state,
                confirmation: action.confirmation,
            };
        case 'CREATE_CONFIRMATION_LIST_INVENTORY':
            return {
                ...state,
                confirmationList: action.confirmationList
            };

        case 'CREATE_CONFIRMATION_LIST_INVENTORY_ALL':
            return {
                ...state,
                confirmationListAll: action.confirmationListAll
            };

        case 'UPDATE_CONFIRMATION_LIST_INVENTORY': {
            state.confirmationList.unshift(action.confirmation);
            const data = state.confirmationList.reverse((i) => i.order);
            return {
                ...state,
                confirmationList: data
            };
        }
        case 'UPDATE_CONFIRMATION_LIST_INVENTORY_ALL':
            return {
                ...state,
                confirmationListAll: [...state.confirmationListAll, action.confirmation],
            };
        case 'UPDATE_PENDING_LIST_INVENTORY': {
            const dataPending = state.pendingList.slice(0);
            const findIndex = dataPending.findIndex((i) => {
                return i.partnumberCode === action.confirmation.partnumberCode;
            });

            dataPending.splice(findIndex, 1);
            return {
                ...state,
                pendingList: dataPending,
            };
        }
        case 'RESET_CONFIGURATION_INVENTORY':
            return {
                ...state,
                inventoryConfig: INITIAL_STATE.inventoryConfig,
            };
        case 'UPDATE_CONFIRMATION_LIST_DRONE': {
            return {
                ...state,
                confirmationListDrone: action.confirmationListDrone,
            };
        }

        case 'CREATE_DIVERGENT_LIST': {
            return {
                ...state,
                divergentList: action.divergentList,
            };
        }

        case 'UPDATE_DIVERGENT_LIST': {
            const dataDivergent = state.divergentList;
            if (action.confirmation.quantity !== 1) {
                dataDivergent.push({
                    shortCode: action.confirmation.shortcode,
                    productId: action.confirmation.productid,
                    inventoryId: action.confirmation.inventoryid,
                    partNumber: action.confirmation.partnumber,
                    expectedQuantity: action.confirmation.quantity,
                    quantity: action.confirmation.quantity,
                    diference: action.confirmation.quantity - 1
                });
            }
            if (action.confirmation.itemAdd) {
                dataDivergent.push({
                    shortCode: action.confirmation.shortcode,
                    productId: action.confirmation.productid,
                    inventoryId: action.confirmation.inventoryid,
                    partNumber: action.confirmation.partnumber,
                    expectedQuantity: 0,
                    quantity: action.confirmation.quantity,
                    diference: action.confirmation.quantity

                });
            }
            return {
                ...state,
                divergentList: dataDivergent,
            };
        }

        case 'RESET_CONFIRMATIONS_DRONE':
            return {
                ...state,
                confirmationListDrone: INITIAL_STATE.confirmationListDrone,
                divergentList: state.divergentList.filter((i) => i.inventoryId !== 270),
                confirmationList: state.confirmationList.filter((i) => i.chargE_ID !== 270),
                pendingList: state.inventoryList
            };
        case 'UPDATE_PENDING_SEND_ITENS': {
            let dataPendingSent = [];
            if (state.confirmationPendingSentItens !== undefined) {
                dataPendingSent = state.confirmationPendingSentItens;
            }

            return {
                ...state,
                confirmationPendingSentItens: [...dataPendingSent, action.confirmationPending],
            };
        }
        case 'UPDATE_SENT_ITEM_CONFIRMATION_LIST': {
            const dataAux = state.confirmationList;
            const parProductId = action.productId;
            const item = dataAux.find((i) => { return i.productId === parProductId && i.IndSent === 0; });
            item.IndSent = 1;

            return {
                ...state,
                confirmationList: state.confirmationList
            };
        }
        default:
            return state;
    }
}
